import React, {useCallback, useState} from 'react';
import {Banner, Button, Caption, DropZone, Icon, List, Stack} from "@shopify/polaris";
import {CancelSmallMinor} from '@shopify/polaris-icons';
import fetch from 'cross-fetch';

const CsvUpload = ({presignedUrl, uploadSuccess, uploadFailure, onCancel, afterButtonDiv, getSignedUrlCallback}) => {
    const getSignedUrl = async () => {
        setLoading(true);
        if (getSignedUrlCallback) {
            const json = await getSignedUrlCallback();
            if (json && json.url) {
                uploadFile(json);
            } else {
                setLoading(false);
            }
        } else {
            fetch(presignedUrl)
                .then((response) => {
                    if (response.ok) {
                        response.json().then((json) => {
                            uploadFile(json);
                        });
                    } else {
                        setLoading(false);
                    }
                });
        }
    }

    const uploadFile = json => {
        fetch(json.url,
            {
                method: 'put',
                headers: {
                    'Content-Type': file.type,
                    'Cache-Control': 'max-age=0',
                },
                body: file,
            })
            .then((response) => {
                if (response.ok) {
                    uploadSuccess(response, json);
                    setLoading(false);
                } else {
                    uploadFailure(response, json);
                    setLoading(false);
                }
            })
    }

    const [file, setFile] = useState();
    const [loading, setLoading] = useState(false);
    const [rejectedFiles, setRejectedFiles] = useState([]);
    const hasError = rejectedFiles.length > 0;
    const handleDrop = useCallback(
        (_droppedFiles, acceptedFiles, rejectedFiles) => {
            setFile(acceptedFiles[0]);
            setRejectedFiles(rejectedFiles);
        },
        [],
    );
    const fileUpload = !file && <DropZone.FileUpload/>;
    const removeFile = (event) => {
        setFile();
        event.stopPropagation();
    };
    const uploadedFile = file && (
        <Stack alignment="center">
            <div>
                {file.name} <Caption>{file.size} bytes</Caption>
                <span style={{cursor: 'pointer'}} onClick={removeFile}><Icon source={CancelSmallMinor}/></span>
            </div>
        </Stack>

    );

    const errorMessage = hasError && (
        <Banner
            title="The following files could not be uploaded:"
            status="critical"
        >
            <List type="bullet">
                {rejectedFiles.map((file, index) => (
                    <List.Item key={index}>
                        {`"${file.name}" is not supported. File type must be .csv`}
                    </List.Item>
                ))}
            </List>
        </Banner>
    );

    return (
        <Stack vertical>
            {errorMessage}
            <DropZone accept=".csv" onDrop={handleDrop}>
                {uploadedFile}
                {fileUpload}
            </DropZone>
            <div>
                {onCancel && <Button onClick={onCancel}>Cancel</Button>}
                {file && <span><Button primary onClick={getSignedUrl} loading={loading}>Upload</Button></span>}
                {afterButtonDiv}
            </div>
        </Stack>
    );
};

export default CsvUpload;
